import React, { useState, useEffect } from 'react';
import Splash from "./auth/splash";
import { Routes, Route, Link } from "react-router-dom";
import Login from "./auth/login";
import Welcome from "./auth/welcome";
import Signup from "./auth/signup";
import HomePage from "./home/home";
import { initializeApp } from 'firebase/app';
import Admin from './auth/adminPage';
import PrivacyPolcity from './home/privacyPolicy';
import PrivacyPolicy from './home/privacyPolicy';




function App() {

    return(
        <Routes>
            <Route path="/" element={<Splash/>} />
            <Route path="/login" element={<Login/>} />
            <Route path="/welcome" element={<Welcome/>} />
            <Route path="/login" element={<Login/>} />
            <Route path="/signup" element={<Signup/>} />
            <Route path="/home" element={<HomePage/>} />
            <Route path="/admin" element={<Admin/>} />
            <Route path="/privacy" element={<PrivacyPolicy/>} />
        </Routes>
    )
}

export default App;
